import cloneDeep from 'lodash/cloneDeep';

import { DeliveryArea, DeliveryAreaError } from 'lib/types/deliveryAreas';
import { camelCase, removeNull } from 'lib/utils/objectSerializer';
import cleanError from 'lib/utils/cleanError';

import {
  INIT_DELIVERY_AREA,
  UPDATE_DELIVERY_AREA,
  API_READ_DELIVERY_AREA_REQUEST,
  API_READ_DELIVERY_AREA_SUCCESS,
  API_READ_DELIVERY_AREA_FAILURE,
  API_SAVE_DELIVERY_AREA_REQUEST,
  API_SAVE_DELIVERY_AREA_SUCCESS,
  API_SAVE_DELIVERY_AREA_FAILURE,
  API_DELETE_DELIVERY_AREA_REQUEST,
  API_DELETE_DELIVERY_AREA_SUCCESS,
  API_DELETE_DELIVERY_AREA_FAILURE,
} from './actionTypes';
import { DeliveryAreaDetailAction } from './actions';

export interface DeliveryAreaDetailState {
  loading: boolean;
  saving: boolean;
  deleting: boolean;
  deliveryArea?: Partial<DeliveryArea>;
  pristineDeliveryArea?: DeliveryArea;
  error?: DeliveryAreaError;
}

export const initialState: DeliveryAreaDetailState = {
  loading: false,
  saving: false,
  deleting: false,
};

export default function deliveryAreasReducer(
  state: DeliveryAreaDetailState = initialState,
  action: DeliveryAreaDetailAction,
): DeliveryAreaDetailState {
  switch (action.type) {
    case INIT_DELIVERY_AREA: {
      return { ...state, deliveryArea: {} };
    }

    case UPDATE_DELIVERY_AREA:
      return {
        ...state,
        deliveryArea: { ...state.deliveryArea, ...action.update },
        error: cleanError(action.update, state.error),
      };

    case API_READ_DELIVERY_AREA_REQUEST:
      return {
        ...state,
        loading: true,
        deliveryArea: undefined,
        error: undefined,
      };

    case API_READ_DELIVERY_AREA_SUCCESS: {
      const deliveryArea = removeNull(camelCase(action.payload));
      const pristineDeliveryArea = cloneDeep(deliveryArea);
      return {
        ...state,
        loading: false,
        deliveryArea,
        pristineDeliveryArea,
      };
    }

    case API_READ_DELIVERY_AREA_FAILURE:
      return { ...state, loading: false, error: camelCase(action.payload) };

    case API_SAVE_DELIVERY_AREA_REQUEST:
      return { ...state, saving: true };

    case API_SAVE_DELIVERY_AREA_SUCCESS: {
      const deliveryArea = removeNull(camelCase(action.payload));
      const pristineDeliveryArea = cloneDeep(deliveryArea);
      return {
        ...state,
        saving: false,
        deliveryArea,
        pristineDeliveryArea,
      };
    }

    case API_SAVE_DELIVERY_AREA_FAILURE:
      return { ...state, saving: false, error: camelCase(action.payload) };

    case API_DELETE_DELIVERY_AREA_REQUEST:
      return { ...state, deleting: true };

    case API_DELETE_DELIVERY_AREA_SUCCESS:
    case API_DELETE_DELIVERY_AREA_FAILURE: {
      return { ...state, deleting: false };
    }

    default:
      return state;
  }
}
